import scroll from '../helpers/scroll';

export default class BgGraphic {

	constructor () {
		scroll.listen((percentScrolled) => {
			document.documentElement.style.setProperty(
				'--bg-graphic-offset',
				(percentScrolled * 300) + 'px'
			);
		});
	}

}